package br.com.texeratx.boardgametimeapp.data.model.match

@kotlinx.serialization.Serializable
data class UpdateMatchRequest(
    val date: String,
    val duration: Int,
    val observation: String? = null,
    val scores: List<UpdateMatchScoreRequest>,
    val clanExpansionIds: List<Long> = emptyList()
)

@kotlinx.serialization.Serializable
data class UpdateMatchScoreRequest(
    val playerId: Long,
    val points: Double
)
